import { createStore, applyMiddleware, compose } from "redux";
import { composeWithDevTools } from "redux-devtools-extension";
import createSagaMiddleware from "redux-saga";

export default (rootReducer: any, rootSaga: any) => {
  const middleware: any = [];
  const enhancers: any = [];

  const sagaMiddleware: any = createSagaMiddleware();
  middleware.push(sagaMiddleware);

  enhancers.push(composeWithDevTools(applyMiddleware(...middleware)));

  const createAppropriateStore = createStore;
  const store = createAppropriateStore(rootReducer, compose(...enhancers));

  const sagasManager = sagaMiddleware.run(rootSaga);

  return {
    store,
    sagasManager,
    sagaMiddleware,
  };
};
